module.exports = __webpack_public_path__ + "img/HSD-title.928076cf.png";